<app-panel
  title="Lokalizacje magazynów">
  Storage works
</app-panel>
